
<template>
  <div>
    <v-row class="px-3">
      <v-col cols='6'>
        <v-autocomplete
          :loading="!allPayOpts"
          v-model="deal.payment_option_id"
          :items="allPayOpts"
          item-value="id"
          item-text="attributes.description"
          label="Modo de pagamento"
          prepend-icon="mdi-credit-card"
          hide-no-data
          :rules="[rules.required]"
        >
          <v-slide-x-reverse-transition slot="append-outer" mode="out-in"></v-slide-x-reverse-transition>
        </v-autocomplete>
      </v-col>
      <v-col cols='6'>
        <v-autocomplete
          :loading="!allPayTimes"
          v-model="deal.payment_time_id"
          :items="allPayTimes"
          item-value="id"
          item-text="attributes.description"
          label="Prazo de pagamento"
          prepend-icon="mdi-calendar-range"
          hide-no-data
          :rules="[rules.required]"
        >
          <v-slide-x-reverse-transition slot="append-outer" mode="out-in"></v-slide-x-reverse-transition>
        </v-autocomplete>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  props: {
    deal: {
      type: Object,
    },
  },
  data() {
    return {
      key: null,
      rules: {
        required: v => !!v || 'Campo é necessário',
        notZeroPercentage: v => (!!v && v != '0.00' && parseFloat(v) < 100) || 'Formato válido: "99.99"',
        notZero: v=> v != '0.00' || 'Não pode ser zero',
        email: v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail deve ser válido',
        cpf: v => (v && v.length == 11) || 'CPF deve ser completo',
      },
    }
  },
  methods: {
    ...mapActions({
      getPayments: 'PaymentOption/index',
    })
  },
  created () {
    this.getPayments('options')
    this.getPayments('times')
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      allPayOpts: state => state.PaymentOption.allPayOpts,
      allPayTimes: state => state.PaymentOption.allPayTimes,
    })
  },

}
</script>
